export enum MessageDirection {
    INCOMING = 'INCOMING',
    OUTGOING = 'OUTGOING'
}

export enum MessageSenderType {
    USER = 'USER',
    AI = 'AI',
    ADMIN = 'ADMIN',
    SYSTEM = 'SYSTEM'
}

export type MessageDeliveryStatus = 'PENDING' | 'SENT' | 'DELIVERED' | 'READ' | 'FAILED';

export interface Message {
    id: string; // uuid
    sessionId: string;
    workerId: string;
    message: string;
    translatedMessage?: string; // Translation of the message (optional)
    sourceLanguage?: string; // Original language of the message
    targetLanguage?: string; // Language the message was translated to
    direction: MessageDirection;
    senderType: MessageSenderType;
    receivedAt: string; // Assuming string representation from backend (e.g., ISO date string)
    adminUsername?: string; // Optional: username of the admin who sent the message
    clientRequestId?: string;
    logicalSendKey?: string;
    deliveryStatus?: MessageDeliveryStatus;
    // The 'session' relation is likely not needed directly in the frontend message model
    // if messages are fetched in the context of a session already.
}
